import axios from 'axios';

export const postSwrFetcherWithFile = async <T, R>(url: string, { arg }: { arg: T }) => {
  // https://axios-http.com/docs/multipart
  const response = await axios.postForm<R>(url, arg);

  return response.data;
};
